import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * 현재 로그인된 사용자를 Supabase에서 로그아웃 처리합니다.
 */
export async function signOut() {
  if (!isSupabaseConfigured) {
    return { error: null };
  }

  try {
    const { error } = await supabase.auth.signOut();
    if (error) {
      return { error };
    }
    return { error: null };
  } catch (err) {
    return {
      error: err instanceof Error ? err : new Error('로그아웃 중 오류가 발생했습니다.'),
    };
  }
}
